import { render, staticRenderFns } from "./ContractPlaceInfo.vue?vue&type=template&id=703cf1f8&scoped=true&"
import script from "./ContractPlaceInfo.vue?vue&type=script&lang=js&"
export * from "./ContractPlaceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703cf1f8",
  null
  
)

export default component.exports